// extracted by mini-css-extract-plugin
export var backdropBlur = "_cl-0";
export var contentCard = "_cl-5";
export var frame = "_cl-2";
export var image = "_cl-4";
export var imagePane = "_cl-3";
export var modal = "_cl-1";